export const baseConfigMixin = {
  data() {
    return {
      cmsUrl: process.env.VUE_APP_BASE_URL,
      isAdmin: true,
    }
  },
}

export const uploadFileMixin = {
  methods: {
    uploadFile(e, type, id, obj) {
      this.imageLoading = true
      const self = this
      let reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      reader.onload = (res) => {
        let file = document.getElementById(id)
        let fileValue = file.value
        let pos = fileValue.lastIndexOf("\\")
        let fileName = fileValue.substring(pos + 1)
        let fileType = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
        if (type === "picture" && ["jpg", "jpeg", "png", "gif", "svg"].indexOf(fileType.toLowerCase()) === -1) {
          file.value = ""
          self.$Message.error("只支持jpg、jpeg、png、gif和svg格式的图片，请重新上传！")
        } else if (type === "video" && ["mp4", "webm", "ogg"].indexOf(fileType.toLowerCase()) === -1) {
          file.value = ""
          self.$Message.error("只支持mp4、WebM和Ogg格式的视频文件，请重新上传！")
        } else if (type === "pdf" && ["pdf"].indexOf(fileType.toLowerCase()) === -1) {
          file.value = ""
          self.$Message.error("只支持pdf格式的视频文件，请重新上传！")
        }
        obj[id] = res.target.result
        self.imageLoading = false
      }
    },
  },
}
